/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { GpsSourcePb_Enum, gpsSourcePb_EnumFromJSON, gpsSourcePb_EnumToJSON } from "../../../../gen/sensors/gps_source";

export const protobufPackage = "skills";

export interface SetDesiredGpsSourceActionArgs {
  source: GpsSourcePb_Enum;
}

export interface SetDesiredGpsSourceResultData {
}

export interface SetDesiredGpsSourceActionStateData {
}

function createBaseSetDesiredGpsSourceActionArgs(): SetDesiredGpsSourceActionArgs {
  return { source: 0 };
}

export const SetDesiredGpsSourceActionArgs = {
  encode(message: SetDesiredGpsSourceActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.source !== 0) {
      writer.uint32(8).int32(message.source);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetDesiredGpsSourceActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetDesiredGpsSourceActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.source = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SetDesiredGpsSourceActionArgs {
    return { source: isSet(object.source) ? gpsSourcePb_EnumFromJSON(object.source) : 0 };
  },

  toJSON(message: SetDesiredGpsSourceActionArgs): unknown {
    const obj: any = {};
    if (message.source !== 0) {
      obj.source = gpsSourcePb_EnumToJSON(message.source);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SetDesiredGpsSourceActionArgs>, I>>(base?: I): SetDesiredGpsSourceActionArgs {
    return SetDesiredGpsSourceActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetDesiredGpsSourceActionArgs>, I>>(
    object: I,
  ): SetDesiredGpsSourceActionArgs {
    const message = createBaseSetDesiredGpsSourceActionArgs();
    message.source = object.source ?? 0;
    return message;
  },
};

function createBaseSetDesiredGpsSourceResultData(): SetDesiredGpsSourceResultData {
  return {};
}

export const SetDesiredGpsSourceResultData = {
  encode(_: SetDesiredGpsSourceResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetDesiredGpsSourceResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetDesiredGpsSourceResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetDesiredGpsSourceResultData {
    return {};
  },

  toJSON(_: SetDesiredGpsSourceResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetDesiredGpsSourceResultData>, I>>(base?: I): SetDesiredGpsSourceResultData {
    return SetDesiredGpsSourceResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetDesiredGpsSourceResultData>, I>>(_: I): SetDesiredGpsSourceResultData {
    const message = createBaseSetDesiredGpsSourceResultData();
    return message;
  },
};

function createBaseSetDesiredGpsSourceActionStateData(): SetDesiredGpsSourceActionStateData {
  return {};
}

export const SetDesiredGpsSourceActionStateData = {
  encode(_: SetDesiredGpsSourceActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SetDesiredGpsSourceActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSetDesiredGpsSourceActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): SetDesiredGpsSourceActionStateData {
    return {};
  },

  toJSON(_: SetDesiredGpsSourceActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<SetDesiredGpsSourceActionStateData>, I>>(
    base?: I,
  ): SetDesiredGpsSourceActionStateData {
    return SetDesiredGpsSourceActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SetDesiredGpsSourceActionStateData>, I>>(
    _: I,
  ): SetDesiredGpsSourceActionStateData {
    const message = createBaseSetDesiredGpsSourceActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
